// TODO: Refactor
import { FC, useState } from 'react';
import React from 'react';
import { PlatformName, UseCase } from '@app/app/analytics/types';
import { analytics } from '@app/app/analytics';
import { usePersistedUseCaseStore } from '@app/app/persist';
import { COOKIE_KEY, cookieUtils } from '@app/app/cookie';
import { useTranslation } from '@app/app/i18n';

const QUIZ_ITEMS_KEYS = [
  'quiz.items.teaching',
  'quiz.items.hr',
  'quiz.items.marketing',
  'quiz.items.sales',
  'quiz.items.management',
  'quiz.items.student',
  'quiz.items.other',
] as const;

const QUIZ_VALUES: UseCase[] = [
  'teaching_and_training',
  'hr_and_people_development',
  'marketing',
  'sales',
  'management',
  'im_a_student',
  'other_category',
];

export const RegisterQuiz: FC<{ close: () => void; isLoading: boolean }> = (props) => {
  const { t } = useTranslation('auth');
  const { close, isLoading } = props;
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  const { setUseCase } = usePersistedUseCaseStore();
  const submit = () => {
    if (activeItem === null) return;
    const answer = QUIZ_VALUES[activeItem];
    setIsFetching(true);
    setUseCase(answer);
    cookieUtils.set(COOKIE_KEY.useCase, answer);
    analytics.emitEvent('onboarding_submit', {
      [PlatformName.GTM]: { usecase: answer },
    });
    close?.();
  };
  function skipQuizHandler() {
    setUseCase('skip');
    cookieUtils.set(COOKIE_KEY.useCase, 'skip');

    analytics.emitEvent('onboarding_submit', {
      [PlatformName.GTM]: { usecase: 'skip' },
    });
    close?.();
  }

  return (
    <div className="auth_quiz__container">
      <div className="auth_title">{t('quiz.title')}</div>
      <div className="auth_quiz_text">
        {t('quiz.description')
          .split('\n')
          .map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i < t('quiz.description').split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
      </div>
      <div className="auth_quiz_quest">{t('quiz.quest')}</div>
      <ul className="auth_quiz_items">
        {QUIZ_ITEMS_KEYS.map((key, i) => (
          <li
            className={'auth_quiz_item' + (activeItem === i ? ' active' : '')}
            key={i}
            onClick={() => {
              setActiveItem(i);
            }}
          >
            {t(key)}
          </li>
        ))}
      </ul>
      <div className="auth_quiz_btn__wrapper">
        <div>
          <button
            type="button"
            className="auth_quiz_skip_btn"
            onClick={skipQuizHandler}
            disabled={isFetching || isLoading}
          >
            {t('quiz.skipBtn')}
          </button>
        </div>
        <button
          type="button"
          className={
            'main_btn auth_quiz_btn' +
            (activeItem === null || isFetching || isLoading ? ' auth_quiz_btn__disabled' : '')
          }
          disabled={activeItem === null || isFetching || isLoading}
          onClick={submit}
        >
          {t('quiz.submit')}
        </button>
      </div>
    </div>
  );
};
